export const ContractTypeEnum = Object.freeze({
	NDA: "NDA",
	CONTRATO: "Contrato",
});
